import { Avatar, AvatarTypes } from 'APP/components/Avatar/Avatar';

import styles from './styles.m.css';

const NoVideoPlaceholder = ({ streamer }) => {
  return (
    <Avatar
      className={styles.container}
      type={AvatarTypes.Round_25}
      title={streamer.username}
      url={streamer.avatarUrl}
      backgroundColorIndex={streamer.avatarColorIndex}
    />
  );
};

export default NoVideoPlaceholder;
